
    <div>
      <file-add [label]="'Add documentation files'"  [infoText]="infoText"
      [id]="'docUpload'" (onFileUpload)="uploadFiles($event)"></file-add>
  </div>